module.exports = __webpack_public_path__ + "static/Karuna.fcf592aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Karuna.jpg
// module id = 242
// module chunks = 25111403944408 251948199435738